import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Typography from '../../atoms/typography';

const dynamicHeight = ({ contentHeight }) => `max-height: ${contentHeight}px`;

const AccordionTab = styled.dl`
  border-bottom: 1px solid ${(props) => props.theme.color.brand};
  border-top: 1px solid ${(props) => props.theme.color.brand};
  max-height: ${(props) => (props.active ? props.contentHeight : 35)}px;
  overflow: hidden;
  transition: max-height ${(props) => props.theme.animation.fast} ${(props) => props.theme.animation.easeInQuad};
  
  ${dynamicHeight};

  ~ dl {
    border-top: 0;
  }
`;

const AccordionTitle = styled(Typography)`
  ${(props) => props.theme.arrow(props.active ? 'up' : 'down', props.theme.color.brand, 'right center')}
  color: ${(props) => props.theme.color.brand};
  cursor: pointer;
  display: flex;
  letter-spacing: 0.2em;
  line-height: 3.5rem;
  position: relative;
  text-transform: uppercase;
`;

const AccordionSubTitle = styled(Typography)`
  color: ${(props) => props.theme.color.brandLight};
  flex: 1;
  display: flex;
  letter-spacing: initial;
  text-align: right;
  text-transform: initial;
  padding-right: 2rem;
`;

const AccordionContent = styled.dd`
  padding-bottom: 1rem;
`;

export const PropertyList = styled(Typography)`
  list-style-type: disc;
  margin-left: 1.75rem;

  b {
    font-weight: bold;
  }

  ul > li {
    list-style-type: disc;
  }
`;

class ProductDetailAccordion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false
    };

    this.accordionRef = createRef();

    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.getHeight = this.getHeight.bind(this);
  }

  getHeight() {
    return this.accordionRef.scrollHeight;
  }

  toggleAccordion() {
    this.setState((prevState) => ({ active: !prevState.active }));
  }

  render() {
    return (
      <AccordionTab
        ref={(node) => { this.accordionRef = node; }}
        active={this.state.active ? 'true' : undefined}
        contentHeight={this.getHeight}
      >
        <AccordionTitle element="dt" like="label-1" active={this.state.active ? 'true' : undefined} onClick={this.toggleAccordion}>
          {this.props.title}
          {
            this.props.subtitle && (
              <AccordionSubTitle element="span" like="dec-1">
                {this.props.subtitle}
              </AccordionSubTitle>
            )
          }
        </AccordionTitle>
        <AccordionContent>
          {this.props.children}
        </AccordionContent>
      </AccordionTab>
    );
  }
}

ProductDetailAccordion.defaultProps = {
  subtitle: ''
};

ProductDetailAccordion.propTypes = {
  children: PropTypes.any.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string.isRequired
};

export default ProductDetailAccordion;
